/// <reference path="../../@types/index.d.ts" />
// /\ needed to compiled docs properly
import * as tslib_1 from "tslib";
import * as React from "react";
/**
 * Simple error presentation
 */
var DefaultError = /** @class */ (function (_super) {
    tslib_1.__extends(DefaultError, _super);
    function DefaultError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultError.prototype.renderError = function () {
        return (React.createElement("sb-error-comp", null,
            React.createElement("h2", null, "Something went wrong."),
            React.createElement("details", { style: { whiteSpace: "pre-wrap" } },
                this.props.error && this.props.error.toString(),
                React.createElement("br", null),
                this.props.componentStack)));
    };
    DefaultError.prototype.render = function () {
        return this.renderError();
    };
    return DefaultError;
}(React.Component));
export { DefaultError };
//# sourceMappingURL=DefaultError.js.map